<template>
  <coupon-detail :is-edit='true'>
  </coupon-detail>
</template>

<script>
import CouponDetail from './components/CouponDetail'

export default {
  name: 'EditCoupon',
  components: {
    CouponDetail
  }
}
</script>

